// Source/Steps-Section/Component.ts
import { Swiper } from "Swiper";
class Steps_Slider extends HTMLElement {
  controller;
  disconnectedCallback() {
    this.controller.abort();
  }
  connectedCallback() {
    this.controller = new AbortController;
    this.setup();
  }
  setup() {
    const swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      updateOnWindowResize: true,
      breakpoints: {
        700: {
          enabled: false
        }
      }
    });
    this.controller.signal.addEventListener("abort", () => {
      swiper.destroy();
    });
  }
}

// Source/Steps-Section/mod.ts
customElements.define("steps-slider", Steps_Slider);
